import React, { useEffect, useState } from 'react';
import ContactInquiryList from '../../Components/ContactInquiryItems/ContactInquiryList/ContactInquiryList';
import apiClient from '../../../../../Config/apiClient';
import './ContactInquiries.scss';
import { showErrorToast } from '../../../../../Context/Toaster/Toaster';

const contactInquiriesPath = process.env.REACT_APP_HS_CONTACT_INQUIRIES_BASE_PATH;

const ContactInquiries = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchInquiries = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get(`${contactInquiriesPath}/list`);
      if (response.data.status === 'SUCCESS') {
        setInquiries(response.data.data);
      } else {
        showErrorToast(response.data.error_data?.message || 'Failed to fetch contact inquiries');
      }
    } catch (err) {
      showErrorToast('Failed to fetch contact inquiries');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInquiries();
  }, []);

  return <ContactInquiryList inquiries={inquiries} loading={loading} refreshList={fetchInquiries} />;
};

export default ContactInquiries;
